__webpack_require__.p = "https://localhost:3000/wp-content/themes/eventelec/dist/";